import api from '../api'
const baseUrl = '/academy/api/Collegue'
const skillUpCertificateProvider = {
  AddCertificate(params) {
    return api.post(`${baseUrl}/Add`, params)
  },
  updateCertificate(params) {
    return api.put(`${baseUrl}/Edit`, params)
  },
  getCertificate(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },
  deleteCertificate(id) {
    return api.delete(`${baseUrl}/Delete/${id}`)
  },
}

export default skillUpCertificateProvider
